import React, { Component } from "react";

import Api from "../../../lib/componentApi";

import SelectPayment from "../../../routes/screens/Restaurants/Products/SelectPayment";
import Loading from "../../Common/Loading";

class Tip extends Component {
  constructor(props) {
    super(props);
    this.state = {
      amount: 0,
      customSection: false,
      defaultPayment: null,
      allPayments: [],
      loading: true,
      changePayment: false
    };
  }
  componentDidMount() {
    Api.get("/api/user/payments", {}, (response, errors) => {
      if (errors) {
        if (errors === 503) {
          this.setState(() => {
            throw errors;
          });
        } else {
          console.log(errors);
        }
      } else if (response.code) {
        console.log(response, "tip-payment-code");
      } else {
        if (response.creditCards && response.creditCards.length) {
          this.setState({
            defaultPayment:
              response.creditCards.find(payment => payment.default === true) ||
              response.creditCards[0],
            allPayments: response.creditCards
          });
        }
        this.setState({ loading: false });
      }
    });
  }
  onClickCustomAmount = () => {
    const { customSection } = this.state;
    this.setState({
      customSection: !customSection
    });
  };
  onChangeAmount = (event, value) => {
    event.preventDefault();
    if (!value) {
      this.setState({
        amount: parseFloat(event.target.value) || 0
      });
    } else {
      this.setState({
        amount: parseFloat(value)
      });
    }
  };
  getDisableStatus = () => {
    let disabled = true;
    const { amount, defaultPayment, customSection } = this.state;
    if (customSection) {
      if (amount) {
        disabled = false;
      }
    } else {
      if (defaultPayment && amount) {
        disabled = false;
      }
    }
    return disabled;
  };
  handleSubmitTip = () => {
    const { onSubmitTip, orderUid } = this.props;
    const { defaultPayment, amount, customSection } = this.state;
    if (customSection) {
      this.setState({ customSection: false });
    } else {
      if (defaultPayment) {
        onSubmitTip(orderUid, amount, defaultPayment);
      }
    }
  };
  renderPayWithSection = () => {
    const { defaultPayment } = this.state;
    if (defaultPayment) {
      return (
        <React.Fragment>
          <p>Pay With</p>
          <p>**** **** **** {defaultPayment.last4}</p>
          <p className="card-image">
            <img
              src={`/svg/payment/${defaultPayment.method.toLowerCase()}.svg`}
            />
          </p>
          <a
            href="javascript: void(0)"
            onClick={() => this.setState({ changePayment: true })}
          >
            Change
          </a>
        </React.Fragment>
      );
    } else {
      return (
        <a
          href="javascript: void(0)"
          onClick={() => this.setState({ changePayment: true })}
        >
          + Add a Payment Method
        </a>
      );
    }
  };
  onSubmitMethod = changedPayment => {
    if (changedPayment) {
      this.setState({ defaultPayment: changedPayment, changePayment: false });
    }
  };
  isCustomAmount = () => {
    const { amount } = this.state;
    if (amount) {
      if (amount === 1 || amount === 2 || amount === 5) {
        return false;
      } else {
        return true;
      }
    } else {
      return false;
    }
  };
  onClickChangeAmount = () => {
    this.setState({ amount: 0 });
  };
  render() {
    const { orderUid, onClickClose, driver } = this.props;
    const {
      amount,
      customSection,
      changePayment,
      allPayments,
      loading
    } = this.state;
    const isCustomAmount = this.isCustomAmount();

    return (
      <div className="tip-page">
        <div className="modal-bg" />
        <div className="modal">
          {/* Header */}
          <div className="head-general with-back">
            {(customSection && (
              <a
                href="javascript: void(0)"
                className="back"
                onClick={this.onClickCustomAmount}
              >
                <img src="/png/chevron-left.png" />
              </a>
            )) || <a href="javascript: void(0)" className="back" />}

            {(loading && <Loading />) || <noscript />}
            <h4>Order #{orderUid}</h4>
            <a
              href="javascript: void(0)"
              onClick={() => onClickClose("tipOrder")}
              className="close"
            >
              <i className="icon icon-close" />
            </a>
          </div>
          {/* Header */}
          <div className="modal-body">
            {(changePayment && (
              <SelectPayment
                payments={allPayments}
                onSubmitMethod={this.onSubmitMethod}
                onCloseSelectPayment={() =>
                  this.setState({ changePayment: false })
                }
              />
            )) ||
              (customSection && (
                <div className="white-bg mt-10px head">
                  <div className="form-group">
                    <input
                      className="form-input"
                      value={(amount && amount) || ""}
                      type="number"
                      onKeyPress={evt => {
                        if (
                          (evt.which != 8 &&
                            evt.which != 0 &&
                            evt.which < 48) ||
                          evt.which > 57
                        ) {
                          evt.preventDefault();
                        }
                        if (evt.target.value && evt.target.value.length === 2) {
                          evt.preventDefault();
                        }
                      }}
                      onChange={this.onChangeAmount}
                    />
                  </div>
                  <div className="use-buttons">
                    <button
                      className={
                        (this.getDisableStatus() && "btn btn-gray") ||
                        "btn btn-blue"
                      }
                      onClick={this.handleSubmitTip}
                      disabled={this.getDisableStatus()}
                    >
                      Done
                    </button>
                  </div>
                </div>
              )) || (
                <>
                  <div className="white-bg mt-10px head">
                    <h4>Tip Driver </h4>
                    <p>
                      Add a tip to thank your courier.
                    </p>
                    {(isCustomAmount && (
                      <div>
                        <p>£{parseFloat(amount).toFixed(2)}</p>
                        <a
                          href="javascript: void(0)"
                          onClick={this.onClickChangeAmount}
                          className="color-blue"
                        >
                          Change Amount
                        </a>
                      </div>
                    )) || (
                      <>
                        <ul>
                          <li>
                            <a
                              href="javascript: void(0)"
                              className={(amount === 1 && "active") || ""}
                              onClick={e => this.onChangeAmount(e, 1)}
                            >
                              £1.00
                            </a>
                          </li>
                          <li>
                            <a
                              href="javascript: void(0)"
                              className={(amount === 3 && "active") || ""}
                              onClick={e => this.onChangeAmount(e, 3)}
                            >
                              £3.00
                            </a>
                          </li>
                          <li>
                            <a
                              href="javascript: void(0)"
                              className={(amount === 5 && "active") || ""}
                              onClick={e => this.onChangeAmount(e, 5)}
                            >
                              £5.00
                            </a>
                          </li>
                        </ul>
                        <a
                          href="javascript: void(0)"
                          onClick={this.onClickCustomAmount}
                          className="color-blue visible-xs hide-xs"
                        >
                          Custom Amount
                        </a>
                      </>
                    )}
                  </div>
                  <div className="white-bg payment mt-10px">
                    {this.renderPayWithSection()}
                  </div>
                  <div className="use-buttons fixed-btn">
                    <button
                      className={
                        (this.getDisableStatus() && "btn btn-gray") ||
                        "btn btn-blue"
                      }
                      onClick={this.handleSubmitTip}
                      disabled={this.getDisableStatus()}
                    >
                      Done
                    </button>
                  </div>
                </>
              )}
          </div>
          {/* .modal-body */}
        </div>
        {/* .modal */}
      </div>
    );
  }
}

export default Tip;
